import { hambergerToggle } from "./assets/js/modules/hamburgertoggle.js";
import { initPcNav } from "./assets/js/modules/pcNav.js";
// import { spNavDropToggle } from "./assets/js/modules/spDropToggle.js";
import { pageTopBtnAction } from "./assets/js/modules/pagetopbtn-action.js";
import { cookie } from "./assets/js/modules/cookie.js";
import { loadingAni } from "./assets/js/modules/loadding-ani.js";
import { fadeIn } from "./assets/js/modules/fadeInAni.js";
import { fadeInSelf } from "./assets/js/modules/fadeInAniSelf.js";
// import { modal } from "./assets/js/modules/modal.js";
import { topMvSlider } from "./assets/js/modules/topMVslider.js";
import { linkSlider } from "./assets/js/modules/linkslider.js";
import { accordion } from "./assets/js/modules/accordion.js";
import { scrollHint } from './assets/js/modules/scroll-hint.js';
import { contact } from "./assets/js/modules/contact.js"; 
import { contact_mitsumori_trump } from "./assets/js/modules/contact_mitsumori_trump.js"; 
import { contact_sample } from "./assets/js/modules/contact_sample.js"; 
import { contact_trading } from "./assets/js/modules/contact_mitsumori_trading.js"; 
const $body = $("body");
// spNavDropToggle();
initPcNav();

hambergerToggle();
pageTopBtnAction();
cookie();
loadingAni();
accordion();
fadeIn();
fadeInSelf();
linkSlider();
// modal();

if ($body.hasClass("top")) {
  topMvSlider();

  Fancybox.bind('[data-fancybox]', {
  });   
}
if ($(".p_nukigata").length > 0 || $('.p_ctp').length > 0 || $('.p_design_chu').length > 0) {
  scrollHint();
}

if($('.p-contact').length > 0 || $('.form_mitsumori_trump').length > 0 || $('.form_mitsumori_karuta').length > 0 || $('.form_mitsumori_others').length > 0 || $('.form_mitsumori_trading').length > 0){
  contact();
}

if($('.form_mitsumori_trump').length > 0){
  contact_mitsumori_trump();
}
if($('.form_sample').length > 0){
  contact_sample();
}

if($('.form_mitsumori_trading').length > 0){
  contact_trading();
}

